module.exports = __webpack_public_path__ + "static/media/hira_mnemonics.0882ca21.png";